import styled from 'styled-components'

interface ContainerProps {
  flex?: string
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: start;
  width: 100%;
  height: 100%;
  flex: ${(props) => (props.flex ? props.flex : '1')};
`
